import { api } from '@/api'
import { DetailUnit, UnitsMapTypeRes } from '@/modules/maps/types/unitsMapType'
import { UnitSearchReq } from '@/modules/devices-list/types/newUnitsType'
import _ from 'lodash'
import { setTypeUnits } from '@/store/filterSystemsSlise'
import { setUnits, updateUnits } from '@/store/unitsSlise'
import {
  footerSliceActions,
  mergeFooterTotals,
} from '@/components/Organisms/Footer/slice'

const homeMapService = api.injectEndpoints({
  endpoints: (build) => ({
    getUnitsHomeMap: build.mutation<
      UnitsMapTypeRes,
      Omit<UnitSearchReq, 'page'>
    >({
      query: (body) => ({
        url: '/devices/searchForMap',
        method: 'POST',
        body,
      }),
      transformResponse: (res: UnitsMapTypeRes) => {
        if (res.success) {
          res.data.data.map((unit) => {
            unit.coordinates = JSON.parse(unit.coordinates as any)
            unit.isGroup = false
          })
        }
        return res
      },
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          const {
            totalErrors,
            totalModulesCount,
            totalNotSmart,
            totalPhotoCamera,
            totalServiceable,
            totalSmart,
            totalSmartLampCountErrors,
            totalSmartLampCountSuccess,
            totalSmartTurnCountErrors,
            totalSmartTurnCountSuccess,
            totalVideoCamera,
            totalWarnings,
            totalLighting,
            totalDit,
            totalWeatherStation,
            totalRoad,
            totalTrafficLight,
            totalLightingCurrent,
            totalLightingPerspective,
            totals,
          } = data.data
          const devices = {
            totalErrors,
            totalModulesCount,
            totalNotSmart,
            totalPhotoCamera,
            totalServiceable,
            totalSmart,
            totalSmartLampCountErrors,
            totalSmartLampCountSuccess,
            totalSmartTurnCountErrors,
            totalSmartTurnCountSuccess,
            totalVideoCamera,
            totalWarnings,
            totalLighting,
            totalLightingCurrent,
            totalLightingPerspective,
            totalDit,
            totalWeatherStation,
            totalRoad,
            totalTrafficLight,
            totals: mergeFooterTotals(totals),
          }
          dispatch(footerSliceActions.setCounters(devices))
          const types = structuredClone(data.data.types)
          types.unshift({ id: 0, name: 'Все' })
          dispatch(setTypeUnits(types))
          dispatch(setUnits(data))
        } catch (e) {
          console.error(e)
        }
      },
    }),
    getDetailUnit: build.mutation<DetailUnit, number>({
      query: (id) => ({
        url: '/devices/getDetailsForMap',
        method: 'GET',
        params: { id },
      }),
      transformResponse: (res: { success: boolean; data: DetailUnit }) => {
        res.data.address = res.data.address
          ? res.data.address.replaceAll(/\n/g, '<br/>')
          : '---'
        return res.data
      },
      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          dispatch(updateUnits(data))
        } catch (error) {
          console.error(error)
        }
      },
    }),
    getDetailUnitCluster: build.mutation<DetailUnit, number>({
      query: (id) => ({
        url: '/devices/getAccidentClusterDetails',
        method: 'GET',
        params: { id },
      }),
      transformResponse: (res: { success: boolean; data: DetailUnit }) => {
        res.data.address = res.data.address
          ? res.data.address.replaceAll(/\n/g, '<br/>')
          : '---'
        return res.data
      },
      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          dispatch(updateUnits(data))
        } catch (error) {
          console.error(error)
        }
      },
    }),
  }),
  overrideExisting: false,
})

export const {
  useGetUnitsHomeMapMutation,
  useGetDetailUnitMutation,
  useGetDetailUnitClusterMutation,
} = homeMapService
